import { ToolboxItemContainer } from './styles';
import { IToolboxItem } from '..';
import { useStore } from '../../../../store';
import { TtsContext } from '../../../../contexts/TtsContext';
import { useContext } from 'react';

interface ToolboxItemProps {
  control: IToolboxItem;
  blockId: string;
  selectionId?: string;
}

export const ToolboxItem = ({
  control,
  blockId,
  selectionId,
}: ToolboxItemProps) => {
  const { clearBlockControls, deleteEffectSelection } = useStore();
  const { hideToolbox } = useContext(TtsContext);

  return (
    <ToolboxItemContainer
      onClick={() => {
        if (control.key === 'clear-block') {
          clearBlockControls(blockId);
          hideToolbox();
        } else if (selectionId && control.key === 'clear-selections') {
          deleteEffectSelection(blockId, [selectionId]);
          hideToolbox();
        } else {
          control.openModal && control.openModal();
        }
      }}
    >
      {control.icon}
      <span>{control.label}</span>
      {control.popup && <div className="controlWrapper">{control.popup}</div>}
    </ToolboxItemContainer>
  );
};
